import { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';

import { RouteScreen } from './RouteScreen';
import { useBeforeUnload } from 'hooks/useBeforeUnload';
import { RedirectComponent } from './RedirectComponent';
import { PageNotFound } from './PageNotFound';
import { useRoutes } from './useRoutes';
import { usePartner } from 'components/app/routes/usePartner';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';
import { usePreload } from 'components/app/routes/usePreload';
import type { UseRoutesReturn } from './useRoutes';

export const Routes = () => {
  const {
    isLoginEnabled,
    routes,
    shouldShowPrompt,
    shouldRedirect
  } = useRoutes<UseRoutesReturn>();
  const { partnerPath } = usePartner();

  useBeforeUnload(shouldShowPrompt);
  usePreload(routes);

  return (
    <Switch>
      {routes.map((route, i) => (
        <Route key={i} path={route.path} exact>
          {(props) =>
            shouldRedirect ? (
              <RedirectComponent path={partnerPath} />
            ) : (
              <Suspense fallback={<NsStopgap />}>
                <RouteScreen route={route} isLoginEnabled={isLoginEnabled}>
                  <route.component {...props} />
                </RouteScreen>
              </Suspense>
            )
          }
        </Route>
      ))}
      <Route path="*" render={PageNotFound} />
    </Switch>
  );
};
